import React from "react";

const getPath = (props) => {
  return (
    <path
      clipRule="evenodd"
      fillRule="evenodd"
      d="M697.077 189.378C725.903 185.612 743.559 219.948 723.738 241.222L579.611 395.915C570.938 405.224 568.817 418.867 574.26 430.34L664.709 620.993C677.149 647.214 649.889 674.663 623.548 662.441L432.02 573.573C420.494 568.225 406.856 570.45 397.607 579.189L243.91 724.395C222.773 744.365 188.269 726.995 191.811 698.167L217.567 488.55C219.117 475.936 212.808 463.668 201.649 457.596L16.2103 356.685C-9.29272 342.807 -3.35761 304.622 25.1722 299.027L232.619 258.346C245.102 255.898 254.842 246.09 257.194 233.599L296.283 26.0263C301.659 -2.52079 339.831 -8.75019 353.921 16.6202L456.374 201.094C462.54 212.196 474.867 218.402 487.481 216.754L697.077 189.378Z" 
    />
  );
};

const Star = () => (
  <svg
    width="100%"
    height="100%"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 733 733"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    {getPath()}
  </svg>
);

export default Star;